import { NgModule } from "@angular/core";
import { PlaybookEditorRoutingModule } from "./playbook-editor-routing.module";
import { CommonModule } from "@angular/common";
import { PlaybookComponent } from "./playbook/playbook.component";
import { ContainerComponent } from "./container/container.component";
import { ContainerContentComponent } from "./container-content/container-content.component";
import { ContentBoxComponent } from "./content-box/content-box.component";
import { ImageComponent } from "./ContentComponents/image/image.component";
import { AudioComponent } from "./ContentComponents/audio/audio.component";
import { VideoComponent } from "./ContentComponents/video/video.component";
import { TabComponent } from "./ContentComponents/tab/tab.component";
import { OrderModule } from "ngx-order-pipe";
import { FilterPipeModule } from "ngx-filter-pipe";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ResourceListsComponent } from "./ContentComponents/resource-lists/resource-lists.component";
import { ModalModule } from "ngx-bootstrap/modal";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgxScrollbarAppModule } from "src/app/shared/modules/ngx-scrollbar-app/ngx-scrollbar-app.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { SafePipeModule } from "../shared/modules/safe/safe";
import { SafeHtmlPipeModule } from "../shared/modules/safe-html/safe-html";
import { SwipeOutDirectiveModule } from "../shared/modules/swipe-out/swipe-out";
import { SwipeShowDirectiveModule } from "../shared/modules/swipe-show/swipe-show";
import { FullscreenDirectiveModule } from "../shared/modules/fullscreen/fullscreen";
import { ResizePreviewImageDirectiveModule } from "../shared/modules/resize-preview-image/resize-preview-image";
import { ContainerIsActivePipeModule } from "../shared/modules/container-is-active/container-is-active";
import { AddPageComponent } from "./shared/components/add-page/add-page.component";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { TabsModule } from "ngx-bootstrap/tabs";
import { RatingsModule } from "../shared/modules/ratings/ratings.module";
import { AddEditResourceComponent } from "./ContentComponents/resource-lists/add-edit-resource/add-edit-resource.component";
import { RichTextEditorComponent } from 'src/app/shared/components/rich-text-editor/rich-text-editor.component';
import { AddImageComponent } from "./shared/components/add-image/add-image.component";
import { FileUploadModule } from "ng2-file-upload";
import { NgSelectModule } from "@ng-select/ng-select";
import { TabImageComponent } from "./shared/components/tab-image/tab-image.component";
import { CKEditorInlineModule } from "../shared/modules/ckeditor/ckeditor";
import { ApplyPageTemplateComponent } from "./shared/components/apply-page-template/apply-page-template.component";
import { CopyPageTemplateComponent } from "./shared/components/copy-page-template/copy-page-template.component";
import { PopoverModule } from "ngx-bootstrap/popover";
import { FilterGroupsModule } from "src/app/shared/modules/filter-groups/filter-groups.module";
import { DndModule } from "ngx-drag-drop";
import { SelectTranslationModule } from "../shared/modules/select-translation/select-translation.module";
import { ChallengeBlockComponent } from "./ContentComponents/challenge-block/challenge-block.component";
import { AddEditChallengeBlockComponent } from "./ContentComponents/challenge-block/add-edit-challenge-block/add-edit-challenge-block.component";
import { NavHolderModule } from "./shared/modules/nav-holder.module";
import { ApplyDraftComponent } from "./shared/components/apply-draft/apply-draft.component";
import { PlaybookCustomCssComponent } from "./shared/components/playbook-custom-css/playbook-custom-css.component";
import { LoadSecureAssetsModule } from "../shared/modules/load-secure-assets/load-secure-assets";
import { CopyClipboardDirectiveModule } from "../shared/modules/copyClipboard/copy-clipboard";
import { ColorPickerModule } from "ngx-color-picker";
import { HotspotEditorDirective } from "./shared/directives/hotspot-editor/hotspot-editor.directive";
import { HotspotDragDirective } from "./shared/directives/hotspotdrag/hotspot-drag.directive";
import { HopSpotViewerDirectiveModule } from "projects/playbook-viewer/src/app/playbook-viewer/shared/modules/hop-spot-viewer-directive/hop-spot-viewer-directive.module";
import { UndoRedoComponent } from "./shared/components/undo-redo/undo-redo.component";
import { FormatTimePipe } from "../shared/pipes/format-pipe/format-time.pipe";
import { FilterDropDownModule } from "../shared/modules/filter-dropdown/filter-dropdown.module";
import { VplaybookVideoViewerModule } from "../shared/modules/vplaybook-video-viewer/vplaybook-video-viewer.module";
import { VplaybookAudioPLayerModule } from "../shared/modules/vplaybook-audio-player/vplaybook-audio-player.module";
import { ApplyPlaybookTemplateComponent } from "./shared/components/apply-playbook-template/apply-playbook-template.component";
import { VideoChunksUploadModule } from "../shared/modules/video-chunks-upload/video-chunks-upload.module";
import { MobileEditorComponent } from "./mobile-editor/mobile-editor.component";
import { TextAnimationComponent } from "./content-box/text-animation/text-animation.component";
import { ImageAnimationComponent } from "./content-box/image-animation/image-animation.component";
import { VideoPlaylistComponent } from "./mobile-editor/video-playlist/video-playlist.component";
import { DraftLiveDeleteComponent } from "./shared/components/draft-live-delete/draft-live-delete.component";
import { EditVideoComponent } from "./shared/components/edit-video/edit-video.component";
import { EditAudioComponent } from "./shared/components/edit-audio/edit-audio.component";
import { PlaybookToastComponent } from "./shared/components/playbook-toast/playbook-toast.component";
@NgModule({
    exports: [ContainerContentComponent, ResourceListsComponent],
    declarations: [
        PlaybookComponent,
        ContainerComponent,
        ContainerContentComponent,
        ContentBoxComponent,
        ImageComponent,
        AudioComponent,
        VideoComponent,
        TabComponent,
        AddPageComponent,
        AddImageComponent,
        TabImageComponent,
        ResourceListsComponent,
        AddEditResourceComponent,
        ApplyPageTemplateComponent,
        CopyPageTemplateComponent,
        ChallengeBlockComponent,
        AddEditChallengeBlockComponent,
        ApplyDraftComponent,
        PlaybookCustomCssComponent,
        HotspotEditorDirective,
        HotspotDragDirective,
        UndoRedoComponent,
        FormatTimePipe,
        ApplyPlaybookTemplateComponent,
        MobileEditorComponent,
        TextAnimationComponent,
        ImageAnimationComponent,
        MobileEditorComponent,
        VideoPlaylistComponent,
        DraftLiveDeleteComponent,
        EditVideoComponent,
        EditAudioComponent,
        PlaybookToastComponent,
    ],
    imports: [
        CommonModule,
        OrderModule,
        ReactiveFormsModule,
        ButtonsModule,
        RatingsModule,
        FilterPipeModule,
        CKEditorInlineModule,
        SwipeOutDirectiveModule,
        SwipeShowDirectiveModule,
        FullscreenDirectiveModule,
        RichTextEditorComponent,
        NgSelectModule,
        ResizePreviewImageDirectiveModule,
        ContainerIsActivePipeModule,
        PlaybookEditorRoutingModule,
        NgxScrollbarAppModule,
        ModalModule,
        TooltipModule,
        SafePipeModule,
        FileUploadModule,
        DragDropModule,
        FormsModule,
        SafeHtmlPipeModule,
        PopoverModule,
        DndModule,
        SelectTranslationModule,
        FilterGroupsModule,
        NavHolderModule,
        LoadSecureAssetsModule,
        CopyClipboardDirectiveModule,
        ColorPickerModule,
        HopSpotViewerDirectiveModule,
        FilterDropDownModule,
        TabsModule,
        VplaybookAudioPLayerModule,
        VplaybookVideoViewerModule,
        VideoChunksUploadModule,
    ]
})
export class PlaybookEditorModule {}
